import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Layout } from "../../Components/layout";
import { deleteAllLocalStorage } from "../../Utils/local-storage";
import { Alert, Button, Col, Row } from "react-bootstrap";

export function BiometriaCancelar() {
  const navigate = useNavigate();

  return (
    <Layout>
      <Row className="w-full d-flex flex-column align-items-center justify-content-center gap-4 m-auto">
        <Alert
          variant="warning"
          className="w-auto m-auto rounded-circle border p-4 text-warning border-warning"
        >
          <AlertTriangle style={{ height: "45px", width: "45px" }} />
        </Alert>
        <Col className="d-flex flex-column align-items-center justify-content-center">
          <h1 className="title">Deseja parar agora?</h1>
          <p
            className="mb-5 text-center"
            style={{ color: "var(--text-muted)" }}
          >
            Se você cancelar, seus dados não serão salvos e você precisará
            recomeçar o processo de biometria posteriormente.
          </p>
        </Col>

        <Col className="d-flex flex-column gap-3">
          <Button
            onClick={() => navigate(-1)}
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
            style={{ fontSize: "1.1rem" }}
          >
            Não, quero continuar
          </Button>
          <Button
            onClick={() => {
              deleteAllLocalStorage();
              window.location.href = "https://www.flexconsulta.com.br";
            }}
            variant="danger"
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
            style={{ fontSize: "1.1rem" }}
          >
            Sim, desejo cancelar
          </Button>
        </Col>
      </Row>
    </Layout>
  );
}
